import React from 'react';
import styled from 'styled-components';

const MIN_WIDTH_PERCENT = 5;

const ZoneBar = ({ data }) => {
  if (!data || data.length === 0) return null;

  const visibleData = data.filter(item => Number(item?.percentage) > 0);
  if (visibleData.length === 0) return null;

  const percentages = visibleData.map(item => item.percentage);
  const adjusted = adjustSmallBars(percentages);

  return (
    <Container>
      <BarContainer>
        {visibleData.map((item, index) => (
          <BarSection key={item.id} width={adjusted[index]}>
            <Bar color={item.color} title={`${item.label}: ${Math.round(item.percentage)}% (${item.count})`}>
              <Label>{Math.round(item.percentage)}%</Label>
            </Bar>
          </BarSection>
        ))}
      </BarContainer>
    </Container>
  );
};

export default ZoneBar;

const adjustSmallBars = (percentages) => {
  const smallBars = percentages.map((p) => (p < MIN_WIDTH_PERCENT ? MIN_WIDTH_PERCENT : p));
  const totalSmallBarWidth = smallBars.reduce(
    (sum, p, i) => sum + (percentages[i] < MIN_WIDTH_PERCENT ? MIN_WIDTH_PERCENT : 0),
    0
  );
  const totalOriginalSmallBarWidth = percentages.reduce(
    (sum, p) => sum + (p < MIN_WIDTH_PERCENT ? p : 0),
    0
  );
  const adjustment = totalOriginalSmallBarWidth - totalSmallBarWidth;
  const largeBars = percentages.map((p) => (p >= MIN_WIDTH_PERCENT ? p : 0));
  const totalLargeBarWidth = largeBars.reduce((sum, p) => sum + p, 0);
  return percentages.map((p) => {
    if (p >= MIN_WIDTH_PERCENT) {
      const newPercentage = (p / totalLargeBarWidth) * (totalLargeBarWidth + adjustment);
      return newPercentage;
    }
    return MIN_WIDTH_PERCENT;
  });
};

const Container = styled.div`
  width: 100%;
`;

const BarContainer = styled.div`
  display: flex;
  height: 40px;
  background-color: #f9fafb;
  padding: 10px;
  border-radius: 8px;
  gap: 2px;
  justify-content: space-between;
  /* subtle fade/slide-in on mount */
  opacity: 0;
  transform: translateY(6px);
  animation: fadeInUp 420ms ease forwards;
  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const BarSection = styled.div`
  width: ${props => props.width}%;
  transition: width 420ms cubic-bezier(0.22, 1, 0.36, 1);
`;

const Bar = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.color};
  display: flex;
  align-items: center;
  color: white;
  font-weight: bold;
  border-radius: 4px;
  padding-left: 10px;
  /* subtle color/opacity polish */
  transition: background-color 240ms ease, opacity 240ms ease;
  will-change: width, background-color;
  opacity: 0.95;
  &:hover {
    opacity: 1;
  }
`;

const Label = styled.div`
  font-size: 12px;
`;


